var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    { staticClass: "part" },
    [
      _vm._l(_vm.selected_schema, function(field) {
        return _c("PartsListCell", {
          key: field.name,
          class: _vm.list_class(field),
          attrs: { part: _vm.part, field: field }
        })
      }),
      _vm._v(" "),
      _c("td", { staticClass: "delete-cell" }, [
        _c("input", {
          staticClass: "delete-button",
          attrs: { type: "button", value: "X" },
          on: { click: _vm.delete_this_part }
        })
      ]),
      _vm._v(" "),
      _c("td", { staticClass: "copy-cell" }, [
        _c("input", {
          staticClass: "copy-button",
          attrs: { type: "button", value: "+" },
          on: { click: _vm.copy_this_part }
        })
      ]),
      _vm._v(" "),
      _vm._m(0)
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "move-cell" }, [
      _c("div", { staticClass: "move-handle" }, [_vm._v("↕️")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8d490724", { render: render, staticRenderFns: staticRenderFns })
  }
}